import { z } from 'zod';
import { missionSchema } from '../entities/missionTypes';
const getMissionParamsSchema = z.object({
    missionId: z.string().uuid(),
});
const getMissionResponseSchema = z.object({
    id: z.string().uuid(),
    created: z.number(),
    createdBy: z.string().uuid(),
    updated: z.number(),
    updatedBy: z.string().uuid(),
    data: missionSchema,
    parentId: z.string().uuid().optional(),
    columns: z.any(), // TODO: Change to use Zod typed columns after PLAT-2704
    permissions: z.string().array().optional(), // TODO: Change to required - CRMS-3034
});
const partialGetMissionResponseSchema = getMissionResponseSchema.omit({
    columns: true,
});
export const getMissionFunctionDef = {
    name: 'getMission',
    requestSchema: getMissionParamsSchema,
    responseSchema: getMissionResponseSchema,
};
